import { EnumHelper } from "../Helpers/EnumHelper";

/** The unit used to calculate the other end of a time range given an anchor date. */
enum TimeframeUnit {
    /**
     * A number of hours from the anchor date and time.
     *
     * For example, 24 hours before 10h00 Tuesday will start at 10h00 Monday.
     */
    Hour = 1,

    /**
     * Any time within the day matching the day offset from the given date.
     *
     * For example, 1 day before 10h00 Tuesday will start at 00h00 Monday.
     */
    Day = 2,

    /**
     * A number of hours from the anchor date and time.
     *
     * For example, 1 week before 10h00 Tuesday will start at 00h00 on the preceding Tuesday.
     */
    Week = 3
}

/**
 * A time window for actions like appointment booking.
 *
 * For example, "24 hours" from 9am will refer to 9am the following day. "1 day" from 9am can refer to any time the following day.
 * @see TimeframeUnit for more info
 */
interface Timeframe {
    /** The time value (e.g. number of hours). */
    Value: number;

    /** The time unit (e.g. hour). */
    Unit: TimeframeUnit;
}

/**
 * Get the total number of hours in a given timeframe
 * @param timeframe The timeframe
 */
function TimeframeToHours(timeframe: Timeframe): number {
    if (!timeframe) {
        return 0;
    }

    switch (EnumHelper.getValue(TimeframeUnit, timeframe.Unit)) {
        case TimeframeUnit.Week:
            return timeframe.Value * 24 * 7;

        case TimeframeUnit.Day:
            return timeframe.Value * 24;

        case TimeframeUnit.Hour:
            return timeframe.Value;
    }

    return 0;
}

export { Timeframe, TimeframeToHours, TimeframeUnit };
